import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Btn, InputField } from './UIComponents';

export default function ResidentModal({ onClose, resident, isEdit }) {
  const { B } = useTheme();

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 520,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
    '@media (maxWidth: 768px)': {
      gridTemplateColumns: '1fr',
    },
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 16,
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>
          {isEdit ? 'Edit Resident' : 'Add New Resident'}
        </div>
        <div style={gridStyle}>
          <InputField label="First Name" placeholder="First name" />
          <InputField label="Last Name" placeholder="Last name" />
          <InputField label="Date of Birth" type="date" />
          <InputField label="Room Number" placeholder="e.g. 204" />
          <InputField label="Gender" select options={['Select…', 'Male', 'Female', 'Other']} />
          <InputField label="Admission Date" type="date" />
        </div>
        <InputField label="Primary Diagnosis" placeholder="Enter diagnosis…" />
        <InputField label="Primary Care Physician" placeholder="Dr. Name" />
        <InputField label="Insurance" select options={['Select…', 'Medicaid', 'Medicare', 'Medicaid/Medicare', 'Private Pay']} />
        <InputField label="Emergency Contact" placeholder="Name · Phone" />
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>
            Cancel
          </Btn>
          <Btn color={B.green}>
            {isEdit ? 'Update Resident' : 'Add Resident'}
          </Btn>
        </div>
      </div>
    </div>
  );
}